import React from 'react'
import { useWillPipe } from '@morningtrain/react-helpers'
import { useValue } from '@morningtrain/react-resources'
import { observer } from 'mobx-react'

function RejectIfModelValue ({ name, defaultValue = false }) {

  const modelValue = useValue(name, defaultValue)

  useWillPipe((payload) => {
    return new Promise((resolve, reject) => {
      modelValue ? reject(payload) : resolve(payload)
    })
  }, [modelValue])

  return null
}

export default observer(RejectIfModelValue)
